export function shortenFilename(filename: string): string {
  const maxLength = 15;
  if (filename.length > maxLength) {
    return `${filename.substring(0, maxLength - 2)}...`;
  }
  return filename;
}
